<template>
  <div class="container">
    <div class="col-md-12">
      <div class="col-lg-12 col-md-12 col-sm-12 col-md-12">
        <div class="table-responsive" style="display: block;margin-top: 20px;">
          <h3>Kết quả đấu giá</h3>
          <div class="filter">
            <input
              class="input-search"
              placeholder="Nhập từ khóa tìm kiếm"
              v-model="searchText"
              @keyup.enter="handleSearch"
            />
            <app-button @click="handleSearch" :disabled="isLoading">
              Tìm kiếm
            </app-button>
          </div>
          <table class="table">
            <thead>
              <tr>
                <th>Thời điểm kết thúc phiên</th>
                <th style="min-width: 150px;">Tên phiên đấu giá</th>
                <th>Trạng thái</th>
              </tr>
            </thead>
            <tbody>
              <tr v-if="isLoading">
                <td colspan="3">
                  <app-loading :loading="isLoading" />
                </td>
              </tr>
              <template v-if="!isLoading">
                <tr v-for="i in data" :key="i.Id">
                  <td class="date">
                    {{ i.PhienDauGia.ThoiGianXacNhanTrungGia | formatDate }}
                  </td>
                  <td class="bid">
                    <a style="text-decoration: underline;" v-on:click="view(i.PhienDauGia.Id)">
                      {{ i.PhienDauGia.TenKeHoach }}</a
                    >
                  </td>
                  <td v-if="i.TrangThai == 5" class="username">Thành Công</td>
                  <td v-else-if="i.TrangThai == 6" class="username">
                    Không Thành Công
                    <template v-if="i.GhiChu && i.GhiChu != ''"> (lý do: {{ i.GhiChu }}) </template>
                  </td>
                </tr>
              </template>
            </tbody>
          </table>
          <div class="pagination-wrapper">
            <paginate
              v-model="page"
              :page-count="totalPage"
              :page-range="5"
              :container-class="'pagination'"
              :page-class="'page-item'"
              :page-link-class="'page-link-item'"
              :prev-class="'prev-item'"
              :prev-link-class="'prev-link-item'"
              :next-class="'next-item'"
              :next-link-class="'next-link-item'"
              :break-view-class="'break-view'"
              :break-view-link-class="'break-view-link'"
              prev-text="Trang trước"
              next-text="Trang sau"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import Pagination from 'vue-pagination-2';

import mixin from '@/mixins/mixin.js';
import Auction from '@/common/api/auction';
import CONFIG from '@/common/config';
import AppLoading from '@/components/AppLoading.vue';
import AppButton from '@/components/AppButton.vue';

export default {
  name: 'AuctionResult',
  components: { Pagination, AppLoading, AppButton },
  mixins: [mixin],
  data() {
    return {
      data: [],
      isLoading: false,
      page: 1,
      pageSize: 10,
      totalElements: 0,
      searchText: '',
      preSearchText: ''
    };
  },
  watch: {
    page() {
      this.getAuctionList();
    }
  },
  computed: {
    totalPage() {
      return Math.floor(this.totalElements / this.pageSize);
    }
  },
  created() {
    this.getAuctionList();
  },
  filters: {
    formatDate: function(value) {
      if (!value) return '';
      return moment(String(value)).format('HH:mm:ss DD/MM/YYYY');
    }
  },
  methods: {
    view(id) {
      this.$router.push('/auction/result/' + id);
    },
    getAuctionList() {
      this.isLoading = true;
      Auction.getListAuction({
        typeId: CONFIG.ID_AUCTION_DONE,
        pageIndex: this.page,
        pageSize: this.pageSize,
        keyword: this.searchText
      })
        .then(({ data }) => {
          this.data = data.Data.Data;
          this.totalElements = data.Data.Total;
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    handleSearch() {
      if (this.preSearchText === this.searchText) {
        return;
      }
      this.page = 1;
      this.getAuctionList();
      this.preSearchText = this.searchText;
    }
  }
};
</script>

<style scoped>
table,
th,
td {
  border: 1px solid #e6e6e6;
}
td,
th {
  padding: 10px 15px !important;
}
.filter {
  margin: 12px 0;
}

.pagination-wrapper {
  margin: 12px 0;
  display: flex;
  justify-content: center;
}
</style>



// WEBPACK FOOTER //
// src/views/AuctionResultList.vue